import { cn } from '@discover-lib/utils';

export type ChipVariantProps = {
  /** Adds hover styles for chips that are links or buttons */
  interactive?: boolean;
};

export function chipVariants({ interactive }: ChipVariantProps = {}) {
  return cn(
    'inline-flex items-center gap-1.5 rounded-md bg-gray-100/50 px-2 py-1 text-2xs text-gray-700 sm:text-xs',
    interactive && 'font-normal no-underline transition-colors hover:bg-gray-100'
  );
}
